import Api from "./Api";
import apiPath from "@/constants/api.js";

export default {
    setHsDesign(options, data) {
        const response = Api().post(apiPath.setHsDesign, data, options);
        return response;
    },

    setBgDesign(options, data) {
        const response = Api().post(apiPath.setBgDesign, data, options);
        return response;
    },

    getDesign(options, data) {
        const response = Api().post(apiPath.getDesign, data, options);
        return response;
    },

    setPopupDesign(options, key, data) {
        const response = Api().post(
            `${apiPath.setPopupDesign}/${key}`,
            data,
            options
        );
        return response;
    },
};
